import { Component } from '@angular/core';

@Component({
  selector: 'my-bill-landing-skeleton',
  templateUrl: './my-bill-landing-skeleton.component.html',
  standalone: false,
})
export class MyBillLandingSkeletonComponent {}
